import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'ngx-user-session-expiration',
	templateUrl: './user-session-expiration.component.html',
	styleUrls: ['./user-session-expiration.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class UserSessionExpirationComponent {

	constructor () {}

}
